"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.testHooks = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ZillowMapContext = _interopRequireDefault(require("./ZillowMapContext"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/ZillowMapOverlay.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ZillowMapOverlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ZillowMapOverlay, _React$Component);

  function ZillowMapOverlay(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.overlay = null;
    return _this;
  }

  var _proto = ZillowMapOverlay.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initializeOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.overlay) {
      // If a non-updatable prop changed, remove the
      // existing overlay so that it will be recreated
      if (this.hasNonUpdatableChange(prevProps)) {
        this.createOverlay();
      } else {
        // Otherwise, update existing overlay if needed
        this.updateOverlay(this.props, prevProps);
      }
    } else {
      this.initializeOverlay();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeOverlay();
  };

  _proto.initializeOverlay = function initializeOverlay() {
    // Create the overlay if the context has been set
    if (this.props.gmap) {
      this.createOverlay();
    }
  };

  _proto.hasNonUpdatableChange = function hasNonUpdatableChange(oldProps) {
    // GroundOverlay does not allow updating URL
    if (oldProps.url !== this.props.url) {
      return true;
    } // GroundOverlay does not allow updating URL


    if (oldProps.north !== this.props.north || oldProps.east !== this.props.east || oldProps.south !== this.props.south || oldProps.west !== this.props.west) {
      return true;
    }

    return false;
  };

  _proto.createOverlay = function createOverlay() {
    var _this$props = this.props,
        url = _this$props.url,
        north = _this$props.north,
        east = _this$props.east,
        south = _this$props.south,
        west = _this$props.west,
        opacity = _this$props.opacity,
        gmap = _this$props.gmap;

    if (this.overlay) {
      this.removeOverlay();
    }

    this.overlay = new google.maps.GroundOverlay(url, {
      north: north,
      east: east,
      south: south,
      west: west
    }, {
      opacity: opacity,
      clickable: false,
      map: gmap
    });
  };

  _proto.updateOverlay = function updateOverlay(_ref, _ref2) {
    var newOpacity = _ref.opacity;
    var existingOpacity = _ref2.opacity;

    if (newOpacity !== existingOpacity) {
      this.overlay.setOpacity(newOpacity);
    }
  };

  _proto.removeOverlay = function removeOverlay() {
    if (this.overlay) {
      this.overlay.setMap(null);
      this.overlay = null;
    }
  };

  _proto.render = function render() {
    return null;
  };

  return ZillowMapOverlay;
}(_react.default.Component);

ZillowMapOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.shape({}).isRequired,
  url: _propTypes.default.string.isRequired,
  north: _propTypes.default.number.isRequired,
  east: _propTypes.default.number.isRequired,
  south: _propTypes.default.number.isRequired,
  west: _propTypes.default.number.isRequired,
  opacity: _propTypes.default.number
} : {};
ZillowMapOverlay.defaultProps = {
  opacity: 1
};

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107
    },
    __self: this
  }, function (contextData) {
    if (contextData.gmap) {
      return _react.default.createElement(ZillowMapOverlay, _extends({}, props, contextData, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111
        },
        __self: this
      }));
    }

    return null;
  });
};

var testHooks = {
  ZillowMapOverlay: ZillowMapOverlay
};
exports.testHooks = testHooks;
var _default = mapContextToProps;
exports.default = _default;